import { IconContext } from "react-icons";
import React from "react";
import { css } from "styled-components";

// screen width checks
export const isMobile = () => window.innerWidth <= 767 ? true : false;
export const isTablet = () =>
    window.innerWidth >= 768 && window.innerWidth <= 1023 ? true : false;
export const isDesktop = () => !isMobile() && !isTablet();

export const ConditionalWrapper = ({ condition, wrapper, children }) =>
    condition ? wrapper(children) : children;

export const Icon = ({ icon, color, className }) => (
    <IconContext.Provider value={{ color, className }}>
        {icon}
    </IconContext.Provider>
);
export const remCalc = px => `${px / 16}rem`;

export function getWidthString(size, cols) {
    if (!size) return;
    let width = (size / Number(cols)) * 100;
    return `width: ${width}%`;
}
export const hexToRGB = (hex, alpha) => {
    if (typeof hex !== "string") return "";

    const r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);

    return alpha ? `rgba(${r},${g},${b},${alpha})` : `rgb(${r},${g},${b})`;
};

export const media = {
    hide: (from, to) => {
        const min = css`and (min-width: ${({ theme }) =>
            theme.breakpoints[
                from === "xxs"
                    ? 0
                    : from === "xs"
                    ? 1
                    : from === "sm"
                    ? 2
                    : from === "md"
                    ? 3
                    : from === "lg"
                    ? 4
                    : from === "xl"
                    ? 5
                    : 0
            ]})`;
        const max = css`and (max-width: ${({ theme }) =>
            theme.breakpoints[
                to === "xxs"
                    ? 0
                    : to === "xs"
                    ? 1
                    : to === "sm"
                    ? 2
                    : to === "md"
                    ? 3
                    : to === "lg"
                    ? 4
                    : to === "xl"
                    ? 5
                    : 0
            ]})`;
        return css`
            @media screen ${from && min} ${to && max} {
                display: none;
            }
        `;
    },
    xxs: {
        up: (...args) => css`
            @media screen and (min-width: ${props =>
                    props.theme.breakpoints[0]}) {
                ${css(...args)};
            }
        `,
        down: (...args) => css`
            @media screen and (max-width: ${props =>
                    props.theme.breakpoints[1]}) {
                ${css(...args)};
            }
        `,
        only: (...args) => css`
            @media screen and (min-width: ${props =>
                    props.theme.breakpoints[0]}) and (max-width: ${props =>
                    props.theme.breakpoints[1]}) {
                ${css(...args)};
            }
        `
    },
    xs: {
        up: (...args) => css`
            @media screen and (min-width: ${props =>
                    props.theme.breakpoints[1]}) {
                ${css(...args)};
            }
        `,
        down: (...args) => css`
            @media screen and (max-width: ${props =>
                    props.theme.breakpoints[2]}) {
                ${css(...args)};
            }
        `,
        only: (...args) => css`
            @media screen and (min-width: ${props =>
                    props.theme.breakpoints[1]}) and (max-width: ${props =>
                    props.theme.breakpoints[2]}) {
                ${css(...args)};
            }
        `
    },
    sm: {
        up: (...args) => css`
            @media screen and (min-width: ${props =>
                    props.theme.breakpoints[2]}) {
                ${css(...args)};
            }
        `,
        down: (...args) => css`
            @media screen and (max-width: ${props =>
                    props.theme.breakpoints[3]}) {
                ${css(...args)};
            }
        `,
        only: (...args) => css`
            @media screen and (min-width: ${props =>
                    props.theme.breakpoints[2]}) and (max-width: ${props =>
                    props.theme.breakpoints[3]}) {
                ${css(...args)};
            }
        `
    },
    md: {
        up: (...args) => css`
            @media screen and (min-width: ${props =>
                    props.theme.breakpoints[3]}) {
                ${css(...args)};
            }
        `,
        down: (...args) => css`
            @media screen and (max-width: ${props =>
                    props.theme.breakpoints[4]}) {
                ${css(...args)};
            }
        `,
        only: (...args) => css`
            @media screen and (min-width: ${props =>
                    props.theme.breakpoints[3]}) and (max-width: ${props =>
                    props.theme.breakpoints[4]}) {
                ${css(...args)};
            }
        `
    },
    lg: {
        up: (...args) => css`
            @media screen and (min-width: ${props =>
                    props.theme.breakpoints[4]}) {
                ${css(...args)};
            }
        `,
        down: (...args) => css`
            @media screen and (max-width: ${props =>
                    props.theme.breakpoints[5]}) {
                ${css(...args)};
            }
        `,
        only: (...args) => css`
            @media screen and (min-width: ${props =>
                    props.theme.breakpoints[4]}) and (max-width: ${props =>
                    props.theme.breakpoints[5]}) {
                ${css(...args)};
            }
        `
    },
    xl: {
        up: (...args) => css`
            @media screen and (min-width: ${props =>
                    props.theme.breakpoints[5]}) {
                ${css(...args)};
            }
        `,
        down: (...args) => css`
            @media screen {
                ${css(...args)};
            }
        `,
        only: (...args) => css`
            // Same as media.xl.up - arguably not needed
            @media screen and (min-width: ${props =>
                    props.theme.breakpoints[5]}) {
                ${css(...args)};
            }
        `
    }
};
